export default __webpack_public_path__ + "static/media/group-629.b279a5c0.png";